module.exports = __webpack_public_path__ + "site/img/68.f8338334.jpg";